<!--<template>-->
<!--<div>分销商对账管理-->
<!--  <button @click="jump">详情</button>-->
<!--</div>-->

<!--</template>-->

<!--<script>-->
<!--export default {-->
<!--  name: "Index",-->
<!--  methods:{-->
<!--    jump(){-->
<!--      this.$router.push('/Financial/DealerFinancialManage/Detail')-->
<!--    }-->
<!--  }-->
<!--}-->
<!--</script>-->

<!--<style scoped>-->

<!--</style>-->
<template>
  <div class="page" v-loading="Loading">
    <!--    导出  Export    导入物流信息 importLogisticsInfo-->
    <!--    订单详情   orderDetail-->
    <div class="form-box">
      <el-form @submit.native.prevent label-width="100px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="售后单号:">
              <el-input clearable v-model="searchData.orderAfterSaleNo" placeholder="请输入售后单号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单号:">
              <el-input clearable v-model="searchData.outOrderNo" placeholder="请输入订单号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="退款状态:">
              <el-select @change="selectStatus" clearable v-model="searchData.FinanceStatus" placeholder="请选择"
                class="w100">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!--        <el-form-item label="商品名称:">-->
        <!--          <el-input clearable v-model="searchData.productSkuName" placeholder="请输入商品名称" clearable></el-input>-->
        <!--        </el-form-item>-->


        <!--        <el-form-item label="对账周期：">-->
        <!--          <el-date-picker-->
        <!--              v-model="valueTime"-->
        <!--              type="datetimerange"-->
        <!--              value-format="yyyy-MM-dd HH:mm:ss"-->
        <!--              range-separator="至"-->
        <!--              start-placeholder="开始日期"-->
        <!--              end-placeholder="结束日期"-->
        <!--              @change="handlePicker"-->
        <!--          ></el-date-picker>-->
        <!--        </el-form-item>-->
        <el-form-item>
          <div class="flex">
            <el-button type="primary" @click="searchFun">查询</el-button>
            <el-button @click="resetFun">重置</el-button>
            <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!--列表-->
    <el-table :data="tableList" highlight-current-row element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
      @selection-change="selectCurrentRow" style="width: 100%" border>
      <el-table-column type="selection" width="50" fixed align="center"></el-table-column>
      <el-table-column prop="orderAfterSaleNo" label="售后单号" width="200" align="center"></el-table-column>
      <el-table-column label="类型" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.afterSaleStatus === 1">退款</span>
          <span v-if="scope.row.afterSaleStatus === 2">退货</span>
          <span v-if="scope.row.afterSaleStatus === 3">换货</span>
        </template>
      </el-table-column>
      <el-table-column prop="resellerName" label="分销商" align="center">
        <!--          <template slot-scope="scope">-->
        <!--                        <span v-if="Array.isArray( scope.row.orderPurchases) &&  scope.row.orderPurchases.length > 0">{{-->
        <!--                            scope.row.orderPurchases[0].orderPurchaseNo-->
        <!--                          }}</span>-->

        <!--            &lt;!&ndash;            {{ scope.row.orderPurchases[0]?.orderPurchaseNo }}&ndash;&gt;-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column prop="outOrderNo" label="相关订单号" align="center"></el-table-column>
      <!--        <el-table-column prop="supplierName" label="订单来源" width="120" align="center"></el-table-column>-->
      <el-table-column label="商品名称" align="center">
        <template slot-scope="scope">
          {{
              scope.row.order && scope.row.order.orderItems && scope.row.order.orderItems[0] &&
              scope.row.order.orderItems[0].productSkuName
          }}
        </template>
      </el-table-column>
      <el-table-column prop="afterSaleQuantity" label="退货数量" align="center">
        <!--          <template slot-scope="scope">-->
        <!--                        <span-->
        <!--                            style="display: inline-block;margin-right:10px;"> {{-->
        <!--                            scpe.row.orderPurchases && scope.row.orderPurchases[0] && scope.row.orderPurchases[0].productSupplierName-->
        <!--                          }}</span>-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column prop="afterSaleAmount" label="退款金额" align="center">
        <!--          <template slot-scope="scope">-->
        <!--            {{-->
        <!--              scope.row.orderPurchases && scope.row.orderPurchases[0] && scope.row.orderPurchases[0].productSupplierName-->
        <!--            }}-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column label="退款状态" align="center">
        <!--          <template slot-scope="scope">-->
        <template slot-scope="{row:{financeStatus}}">
          <span v-if="financeStatus === 0">申请中</span>
          <span v-if="financeStatus === 1">已确认</span>
          <span v-if="financeStatus === 2">审核驳回</span>
        </template>
      </el-table-column>
      <!--        <el-table-column prop="orderQuantity" label="待对账金额" width="120" align="center">-->
      <!--        </el-table-column>-->
      <el-table-column width="300" label="操作" fixed="right" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.financeStatus === 0">
            <el-button v-if="yesShow" type="primary" size="mini" @click="yesRefound(scope.row)">确认退款</el-button>
            <el-button v-if="noShow" type="primary" size="mini" @click="noRefound(scope.row)">拒绝退款</el-button>
          </div>
          <div v-if="scope.row.financeStatus === 1">
            <el-tag type="success">已确认退款</el-tag>
          </div>
          <div v-if="scope.row.financeStatus === 2">
            <el-tag type="warning">已拒绝退款</el-tag>
          </div>

          <!--            <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"-->
          <!--                       @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}-->
          <!--            </el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]">
    </el-pagination>
    <!-- 导入物流信息 -->
    <el-dialog title="导入物流信息" width="30%" :visible.sync="logisticsVisible" :show-file-list="false"
      :close-on-click-modal="false">
      <div class="updata_view" v-loading="uploading" element-loading-text="正在上传...">
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="updataLogistics"
          :on-remove="removeLogistics">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xlsx文件
            <el-button type="text" @click="upDataInfo()">下载导入模板
            </el-button>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-preventClick @click="handleExpSubmit(2)">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="确认退款" :visible.sync="yesDialog" width="30%">
      <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容"
        v-model="yesData.financeRemark">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="yesDialog = false">取 消</el-button>
        <el-button type="primary" @click="yesConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="拒绝退款" :visible.sync="noDialog" width="30%">
      <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容"
        v-model="yesData.financeRemark">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="noDialog = false">取 消</el-button>
        <el-button type="primary" @click="noConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  OrderPurchaseGetAll,
  OrderExport,
  OrderLogisticUpload, FinanceHandle,
  OrderAfterSaleGetAll, ExportResellerOrder, OrderAfterSaleExport
} from "../../../api/api";
import { getButtonList } from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      refoundType: null,
      yesDialog: false,
      noDialog: false,
      Ids: null,
      Name: null, //商品名称
      Model: null, //商品型号
      CategoryIds: null, //商品类型
      BrandIds: null, //品牌
      BeginCreationTime: null,
      EndCreationTime: null,
      PageIndex: 1, //页码
      PageSize: 10, //页长
      valueTime: [],
      total: 0,
      Loading: true,
      currentRow: [],
      buttonList_toolBar: [],
      buttonList_table: [],
      yesShow: false,
      noShow: false,
      brandName: '',
      tableList: [{ 'id': 1 }],
      productNavTypeTreeList: [],
      orderSta: '',
      options: [{
        value: 0,
        label: '待处理'
      }, {
        value: 1,
        label: '已确认'
      }, {
        value: 2,
        label: '已拒绝'
      },],
      orderStat: '',
      searchData: {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        beginCreateTime: null,
        endCreateTime: null,
        FinanceStatus: null,
        orderAfterSaleNo: '',
        outOrderNo: '',
        productSkuName: '',
        MultipleAfterSaleType: [1, 2] // 1 退款  2 退货 3  换货
      },
      value: '',
      logisticsVisible: false,
      uploading: false,
      fileLog: null,
      yesData: {
        financeRemark: '',
        id: null,
        financeStatus: null
      }
    };
  },
  created() {
    // this.getProductNavTypeTree();
    // this.getBrandList();
    this.getTableList();
  },
  mounted() {
    this.getSpusOnSale();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });

      this.buttonList_table = tableButtonList;
      console.log('this.buttonList_table', this.buttonList_table);
      this.buttonList_table && this.buttonList_table.forEach((item) => {

        if (item.buttonFunc === 'yesRefound') {
          this.yesShow = true;
          // console.log('item', item.buttonFunc)
        }
        // this.yesShow = item.buttonFunc === 'yesRefound'
      })
      this.buttonList_table && this.buttonList_table.forEach((item) => {
        if (item.buttonFunc === 'noRefound') {
          this.noShow = true;
          // console.log('item', item.buttonFunc)
        }
        // this.noShow = item.buttonFunc === 'noRefound'
      })
      // console.log('yesshow', 'noshow', this.yesShow, this.noShow);
    }
  },
  methods: {
    export() {
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      OrderAfterSaleExport(this.searchData).then(res => {
        console.log('res', res);
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
        let objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = '分销商对账订单.xlsx'
        a.href = objectUrl
        a.click()
        a.remove()
      })
    },
    selectStatus(val) {
      console.log('va', val)

    },
    noConfirm() {
      if (this.yesData.financeRemark == '') {
        return this.$message.error('请输入退款原因')
      }
      this.$confirm("确认拒绝退款吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(async () => {
        let res = await FinanceHandle(this.yesData);
        console.log('rs', res);

        if (res.data.success) {
          this.$message.success('此退款已拒绝')
          await this.getTableList();
        } else {
          this.$message.error(res.data.error.message || '操作失败, 请重试')
        }
        this.noDialog = false
      }).catch(() => {
      });
    },
    yesConfirm() {
      if (this.yesData.financeRemark == '') {
        return this.$message.error('请输入退款原因')
      }
      this.$confirm("确认保存吗?", "提示", {
        type: "warning",
      }).then(async () => {
        let res = await FinanceHandle(this.yesData);
        console.log('rs', res);

        if (res.data.success) {
          this.$message.success('退款成功')
          await this.getTableList();
        } else {
          this.$message.error(res.data.error.message || '退款失败, 请重试')
        }

        this.yesDialog = false
      }).catch(() => {
      });

    },
    yesRefound(row) {
      console.log('yes', row)
      this.refoundType = 1;
      this.yesData.id = row.id;
      this.yesData.financeRemark = '';
      // this.yesData.financeStatus = row.financeStatus;
      this.yesData.financeStatus = 1;
      this.yesDialog = true
    },
    noRefound(row) {
      this.refoundType = 2;
      console.log('no')
      this.yesData.id = row.id;
      this.yesData.financeRemark = '';
      // this.yesData.financeStatus = row.financeStatus;
      this.yesData.financeStatus = 2;
      this.noDialog = true
    },
    dealerDetail() {
      this.$router.push('/Financial/DealerFinancialManage/Detail')
    },
    exportBtn() {
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      OrderExport(this.searchData).then(res => {
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
        let objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = '订单列表数据.xlsx'
        a.href = objectUrl
        a.click()
        a.remove()
      })
    },
    importBtn() {
      this.logisticsVisible = true;
      this.fileLog = null;
    },
    upDataInfo() {
      window.open(
        "https://homeimage.ksaxshop.com/erp/order/%E8%AE%A2%E5%8D%95%E7%89%A9%E6%B5%81%E5%AF%BC%E5%85%A5.xlsx"
      );
    },
    updataLogistics(e) {
      let that = this;
      let index1 = e.raw.name.lastIndexOf(".") + 1;
      let index2 = e.raw.name.length;
      let type = e.raw.name.substring(index1, index2);
      if (type != "xlsx")
        return that.$message.error("请上传文件格式为xlsx文件");
      that.fileLog = e.raw;
    },
    removeLogistics() {
      this.fileLog = null;
    },
    handleExpSubmit() {
      this.uploading = true;
      let formData = new window.FormData();
      formData.append("file", this.fileLog);
      OrderLogisticUpload(formData).then((res) => {
        if (!res.data.result) {
          this.$message.success('上传成功！');
          this.uploading = false;
          this.logisticsVisible = false;
          this.fileLog = null;
          this.getTableList();
        } else {
          this.$message.error(res.data.result);
          this.uploading = false;
        }
      });
    },
    orderDetail(button, index, row) {
      // this.$router.push(
      //   `/OrderManagement/Purchasing/OrderDetail?id=${row.id}`
      // );
    },
    async getTableList(searchData) {
      // setTimeout(() => {
      //   this.Loading = true;
      // },3000)

      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      this.Loading = true;
      let res = await OrderAfterSaleGetAll(this.searchData);
      setTimeout(() => {
        this.Loading = false;
      }, 500)
      if (res.data.success) {
        this.total = res.data.result.totalCount;
        this.tableList = res.data.result.items;
      } else {
        this.$message.error(res.data.error.message);
      }
      console.log('已收货', res);
    },
    addGoods() {
      this.$router.push(`/Product/AddEditSpu`)
    },
    deleteGoods(item, index, row) {
      let list = []
      list.push(row.id)
      ProductDelete({ ids: list }).then(res => {
        if (res.data.success) {
          this.getSpusOnSale()
          this.$message.success('删除成功！')
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    batchDelete() {
      if (!this.currentRow[0])
        return this.$message.error("请选择需要操作的商品");
      let list = this.currentRow.map((v) => {
        return v.id
      });
      ProductDelete({ ids: list }).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功！')
          this.getSpusOnSale()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    getBrandList(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.name = key;
      }
      return new Promise((resolve, reject) => {
        brandGetAll(obj).then((res) => {
          if (res.data.success) {
            this.brandList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getBrandList(queryString);
        cb(res);
      } else {
        let res = await this.getBrandList();
        cb(res);
      }
    },
    handleSelect(item) {
      this.BrandIds = item.id;
    },
    clearBtn(val) {
      this.BrandIds = null
    },
    getProductNavTypeTree() {
      let that = this;
      CategoryGetTree({ parentId: 0 }).then((res) => {
        that.productNavTypeTreeList = this.loopMenuTree(res.data.result.children);
      });
    },
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        item.value = item.data.Id;
        item.label = item.data.Name;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    searchFun() {
      this.searchData.PageIndex = 1;
      this.getTableList();
    },
    handlePicker(date) {
      if (date == null) {
        this.valueTime = []
        this.searchData.beginCreateTime = null
        this.searchData.endCreateTime = null
      } else {
        this.searchData.beginCreateTime = date[0]
        this.searchData.endCreateTime = date[1]
      }
    },
    resetFun() {
      this.searchData = {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        beginCreateTime: null,
        endCreateTime: null,
        FinanceStatus: null,
        orderAfterSaleNo: '',
        outOrderNo: '',
        productSkuName: '',
      };
      this.getTableList();
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    handleCurrentChange(val) {
      this.searchData.PageIndex = val;
      this.getTableList();
    },
    handleSizeChange(e) {
      this.searchData.PageSize = e;
      this.getTableList();
    },
    //获取商品列表
    getSpusOnSale() {
      let that = this;
      let para = {
        Ids: that.Ids,
        Name: that.Name, //商品名称
        Model: that.Model, //商品型号
        CategoryIds: that.CategoryIds, //商品类型
        BrandIds: that.BrandIds, //品牌
        BeginCreationTime: that.BeginCreationTime,
        EndCreationTime: that.EndCreationTime,
        SkipCount: (that.PageIndex - 1) * that.PageSize,
        MaxResultCount: that.PageSize,
      };
      // this.Loading = false;
    },
    handleEdit(item, index, row) {
      this.$router.push(`/Product/AddEditSpu?id=${row.id}`)
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.path == "/Product/ComManagement/EditProduct") {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
};
</script>

<style scoped>
.updata_view {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

